var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._g(_vm._b({attrs:{"type":_vm.show ? 'text' : 'password'}},'el-input',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"el-icon-view",attrs:{"slot":"suffix"},on:{"click":_vm.trigger},slot:"suffix"})])}
var staticRenderFns = []

export { render, staticRenderFns }